import * as React from "react";

import {Route, Switch, Redirect} from "react-router";

import {cs}     from "@Common/react/chain-services";

import {XpresslinksLanding} from "./account/orders/history-route/xpresslinks-route/xpresslinks-landing";
import {BrandedLoginRoute}  from "./brand/branded-login-route";
import {PasswordRoute}      from "./password/password";
import {SsoRoutes}          from './sso/sso-routes';
import {SupportRoute}       from "./support/support";

export const GuestRouteSwitch = () => cs(
    ["ssoRoutes", (_, next) => SsoRoutes({next})],
    ({ssoRoutes}) => (
        <Switch>
            {ssoRoutes.map((route, i) => (
                <Route
                    key={i}
                    exact
                    path={route.path}
                    render={route.render}
                    component={route.component}
                >
                    {route.redirect && <Redirect to={route.redirect}/>}
                </Route>
            ))}
            <Route
                exact
                path="/password"
                component={PasswordRoute}
            />
            <Route
                exact
                path="/support"
                component={SupportRoute}
            />
            <Route
                exact
                path={"/xpresslinks/:orderParams"}
                render={(props) => (
                    <XpresslinksLanding {...props}/>
                )}
            />
            <Route path="/"
                exact
                component={BrandedLoginRoute}
            />
            <Redirect to={"/"}/>
        </Switch>
    )
);

